/**
 * Displays the perdiodic table component.
 * Note: this is hidden when the filter type selection is not set the "Select elements"
 */
import React, { useContext } from "react";
import styled from "styled-components";
import PulseLoader from "react-spinners/PulseLoader";
import PeriodicTableLabels from "./PeriodicTableLabels";
import PeriodicTableRow from "./PeriodicTableRow";
import allElements from "../data/allElements";
import { PeriodicTableContext } from "./PeriodicTableContext";

const PeriodicTable = () => {
  const { filterType, availableElements, productsLoading } = useContext(
    PeriodicTableContext
  );

  const loadingColor = "#cbe8f7";
  const loadingSize = 20;
  const loadingPulseMargin = 7;

  return (
    <>
      {filterType === "elements" && availableElements.length > 0 && (
        <PeriodicTableContainer
          className={`${productsLoading ? "disabled" : ""}`}
        >
          <PeriodicTableLabels />
          <TableContainer>
            <Table className={`${productsLoading ? "load" : ""}`}>
              {allElements.map((row, index) => (
                <PeriodicTableRow key={index} row={row} />
              ))}
            </Table>
          </TableContainer>
          {productsLoading && (
            <Loader className="products-loader">
              <PulseLoader
                color={loadingColor}
                loading={productsLoading}
                size={loadingSize}
                margin={loadingPulseMargin}
              />
            </Loader>
          )}
        </PeriodicTableContainer>
      )}

      {availableElements.length === 0 && (
        <PeriodicTableContainer>
          <Loader className="all-elements-loader">
            <PulseLoader
              color={loadingColor}
              loading={true}
              size={loadingSize}
              margin={loadingPulseMargin}
            />
          </Loader>
        </PeriodicTableContainer>
      )}
    </>
  );
};

export default PeriodicTable;

const PeriodicTableContainer = styled.div`
  position: relative;
  margin-bottom: 3rem;

  &.disabled > * {
    pointer-events: none;
  }
`;

const TableContainer = styled.div`
  @media (max-width: 768px) {
    overflow: scroll;
  }
`;

const Table = styled.div`
  border: none;
  margin: 16px 0;
  width: 100%;

  &.load {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    min-width: 800px;
  }

  &.collapsed {
    max-height: 250px;
    overflow: hidden;
  }
`;

const Loader = styled.div`
  position: absolute;
  left: 50%;
  margin-left: -50px;
  z-index: 99;

  &.products-loader {
    top: 27%;
    margin-top: -50px;
  }

  &.all-elements-loader {
    top: 10%;
  }
`;
